import awards from "../../shared/es.awards";
import branded_quotes from "../../shared/es.branded-quotes";
import verticals from "./es-education-primary.verticals";const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "es-education-primary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contacto | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.es/educacion/contacto/",
                    lang: "es"
                },

            };
        case "es-education-primary-home":
            return {
                page,
                helmet: {
                    meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
                    meta_description:
                        "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
                    canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-primary-solutions":
            return {
                page,
                helmet: {
                    meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
                    meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
                    canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/soluciones/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-primary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Centro de recursos | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.es/educacion-primaria-y-secundaria/recursos/",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-primary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "Programas de aprendizaje de idiomas en línea para K-12 | Rosetta Stone",
                    meta_description: "Los programas de aprendizaje de idiomas en línea de Rosetta Stone motivan a los estudiantes de inglés y de otros idiomas internacionales a hablar con confianza. Consulte precios.",
                    canonical_url: "",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        case "es-education-primary-404":
            return {
                page,
                helmet: {
                    meta_title: "Sitio no encontrado | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.es/educacion/404",
                    lang: "es"
                },
                awards: {
                    visible: true,
                    title: {
                        content: strings.awards_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: awards({ strings })
                },
                branded_quotes: {
                    visible: true,
                    title: {
                        content: strings.branded_quotes_header_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: branded_quotes({ strings })
                },
                verticals: {
                    visible: true,
                    title: {
                        content: strings.verticals_label,
                        align: "center",
                        type: "section-title"
                    },
                    panels: verticals({ strings })
                }
            };
        default:
            return null;
    }
};
